<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ "heading-title.edit" | translate }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="editForm">
        <div class="row">
          @if(!isChangePassword) {
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="name" class="form-label">{{ "label-title.first-name" | translate }}</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                placeholder="{{ 'label-title.enter-first-name' | translate }}"
                formControlName="firstName"
                (keypress)="helper.alphabeticValidation($event)"
              />
              @if (nameInput?.invalid && nameInput?.touched) {
              <div class="invalid-message">
                @if (nameInput?.hasError('required')) {
                <p class="m-0">{{ "label-title.first-name" | translate }} {{ "label-title.is-required" | translate }}</p>
                } @else if (nameInput?.hasError('maxlength')) {
                {{ "label-title.maximum-characters-allowed" | translate : { _CHARACTER: helper.NameMaxLength } }}
                } @else if (nameInput?.hasError('invalidCharacters')) {
                {{ "validation-title.please-enter-valid-characters" | translate }}
                }
              </div>
              }
            </div>
          </div>
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="name" class="form-label">{{ "label-title.last-name" | translate }}</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                placeholder="{{ 'label-title.enter-last-name' | translate }}"
                formControlName="lastName"
                (keypress)="helper.alphabeticValidation($event)"
              />
              @if (lastNameInput?.invalid && lastNameInput?.touched) {
              <div class="invalid-message">
                @if (lastNameInput?.hasError('required')) {
                <p class="m-0">{{ "label-title.last-name" | translate }} {{ "label-title.is-required" | translate }}</p>
                } @else if (lastNameInput?.hasError('maxlength')) {
                {{ "label-title.maximum-characters-allowed" | translate : { _CHARACTER: helper.NameMaxLength } }}
                } @else if (lastNameInput?.hasError('invalidCharacters')) {
                {{ "validation-title.please-enter-valid-characters" | translate }}
                }
              </div>
              }
            </div>
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="email" class="form-label">{{ "label-title.email" | translate }}</label>
              <input type="text" class="form-control" id="email" placeholder="{{ 'label-title.enter-email' | translate }}" formControlName="email" />
              @if (emailInput?.invalid && emailInput?.touched) {
              <div class="invalid-message">
                @if (emailInput?.hasError('required')) {
                <p class="m-0">{{ "label-title.email" | translate }} {{ "label-title.is-required" | translate }}</p>
                } @else if (emailInput?.hasError('pattern')) {
                {{ "validation-title.email-is-invalid" | translate }}
                }
              </div>
              }
            </div>
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="parner-phone" class="form-label">{{ "label-title.phone" | translate }}</label>
              <div class="input-group">
                <div class="input-group-text">{{ profileDetails.countryPhoneCode }}</div>
                <input
                  type="phone"
                  class="form-control"
                  id="phone"
                  formControlName="phone"
                  value="phone"
                  placeholder="{{ 'label-title.enter-phone' | translate }}"
                  (input)="helper.validateNumberInput($event)"
                  [minlength]="helper.minPhoneNumberLength"
                  [maxlength]="helper.maxPhoneNumberLength"
                  (paste)="(false)"
                />
              </div>
              @if (phoneInput?.invalid && phoneInput?.touched) {
              <div class="invalid-message">
                @if (phoneInput?.hasError('required')) {
                <span>{{ "label-title.phone-number" | translate | titlecase }} {{ "label-title.is-required" | translate }}</span>
                } @else if (phoneInput?.hasError('pattern')) {
                <span>{{ "validation-title.phone-is-invalid" | translate }}</span>
                }
              </div>
              }
            </div>
          </div>

          @if(profileDetails.apiKey !== undefined && profileDetails.apiKey !== null && profileDetails.apiKey !== '') {
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="apiKey" class="form-label">{{ "label-title.api-key" | translate }}  
                    <button type="button" class="btn btn-sm btn-outline-secondary ms-2" (click)="copyApiKeyToClipboard()">
                      <i class="ri-file-copy-line"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary ms-2" (click)="openApiKeyGenerationModal()">
                      <i class="ri-refresh-line"></i>
                    </button>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="apiKey"
                  formControlName="apiKey"
                  (keypress)="helper.alphabeticValidation($event)"
                  [disabled]="true"
                  [readOnly]="true"
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="webhookUrl" class="form-label">{{ "label-title.webhook-url" | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="webhookUrl"
                  formControlName="webhookUrl"
                  (keypress)="helper.alphabeticValidation($event)"
                  placeholder="{{ 'label-title.enter-webhook-url' | translate }}"
                />
              </div>
            </div>
          }
          } @else {
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="currentPassword" class="form-label">{{ "label-title.current-password" | translate }}</label>
              <div class="position-relative">
                <input
                  [type]="fieldTextType[1] ? 'text' : 'password'"
                  class="form-control"
                  id="currentPassword"
                  placeholder="{{ 'label-title.current-password' | translate }}"
                  formControlName="password"
                />
                <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon">
                  <i class="mdi align-middle" [ngClass]="{ 'mdi-eye-off-outline': !fieldTextType[1], 'mdi-eye-outline': fieldTextType[1] }" (click)="toggleFieldTextType(1)"></i>
                </button>
              </div>
              @if (passwordInput?.invalid && passwordInput?.touched) {
              <div class="invalid-message">
                @if (passwordInput?.hasError('required')) {
                <span>{{ "label-title.current-password" | translate | titlecase }} {{ "label-title.is-required" | translate }}</span>
                }
              </div>
              }
            </div>
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="newPassword" class="form-label">{{ "label-title.new-password" | translate }}</label>
              <div class="position-relative">
                <input
                  [type]="fieldTextType[2] ? 'text' : 'password'"
                  class="form-control"
                  id="newPassword"
                  placeholder="{{ 'label-title.new-password' | translate }}"
                  formControlName="newPassword"
                />
                <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon">
                  <i class="mdi align-middle" [ngClass]="{ 'mdi-eye-off-outline': !fieldTextType[2], 'mdi-eye-outline': fieldTextType[2] }" (click)="toggleFieldTextType(2)"></i>
                </button>
              </div>
              @if (newPasswordInput?.invalid && newPasswordInput?.touched) {
              <div class="invalid-message">
                @if (newPasswordInput?.hasError('required')) {
                <span>{{ "label-title.new-password" | translate | titlecase }} {{ "label-title.is-required" | translate }}</span>
                } @else if (newPasswordInput?.hasError('invalidPassword')) {
                <span>{{newPasswordInput?.errors?.['invalidPassword']}}</span>
                } @else if (newPasswordInput?.hasError('sameAsCurrentPassword')) {
                <span>{{ "validation-title.new-password-same-as-current" | translate }}</span>
                }
              </div>
              }
            </div>
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="confirmPassword" class="form-label">{{ "label-title.confirm-password" | translate }}</label>
              <div class="position-relative">
                <input
                  [type]="fieldTextType[3] ? 'text' : 'password'"
                  class="form-control"
                  id="confirmPassword"
                  placeholder="{{ 'label-title.confirm-password' | translate }}"
                  formControlName="confirmPassword"
                />
                <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon">
                  <i class="mdi align-middle" [ngClass]="{ 'mdi-eye-off-outline': !fieldTextType[3], 'mdi-eye-outline': fieldTextType[3] }" (click)="toggleFieldTextType(3)"></i>
                </button>
              </div>
              @if (confirmPasswordInput?.invalid && confirmPasswordInput?.touched) {
              <div class="invalid-message">
                @if (confirmPasswordInput?.hasError('required')) {
                <span>{{ "label-title.confirm-password" | translate | titlecase }} {{ "label-title.is-required" | translate }}</span>
                } @else if (confirmPasswordInput?.hasError('mismatch')) {
                <span>{{ "validation-title.new-and-confirm-must-be-match" | translate }}</span>
                }
              </div>
              }
            </div>
          </div>
          }
        </div>
      </form>
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button
            id="update-city-boundry"
            class="btn btn-sm btn-secondary btn-load d-flex align-items-center justify-content-center"
            style="overflow: unset"
            [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }"
            (click)="openVerificationModal()"
          >
            <span class="d-flex align-items-center">
              @if (helper.showBtnLoader[1]) {
              <span class="spinner-border flex-shrink-0">
                <span class="visually-hidden"></span>
              </span>
              } @else {
              <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }">
                {{ "button-title.save" | translate }}
              </span>
              }
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-otp-modal #otpModal (otpVerified)="updateProfile($event)"></app-otp-modal>



<!-- Modal conformation for new api key generation -->
<ng-template #apiKeyGenerationConfirmationModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ "label-title.generate-new-api-key" | translate }}</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="close-api-key-generation-confirmation-modal"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
       <div class="text-center">
        <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width: 80px; height: 80px"></lord-icon>
        <div class="mt-2 fs-15 mx-2 mx-sm-3">
          <h4>{{ "heading-title.are-you-sure" | translate }}</h4>
          <p>
            {{ "label-title.generate-new-api-key-confirmation-message" | translate }}?
          </p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" id="cancel-api-key-generation" (click)="modal.dismiss('cancel click')">
        {{ "button-title.cancel" | translate }}
      </button>
      <button type="button" class="btn btn-danger" id="confirm-api-key-generation" (click)="generateApiKey(); modal.close('confirm click')">
        {{ "button-title.confirm" | translate }}
      </button>
    </div>
  </div>
</ng-template>